import * as z from "zod";

/** @deprecated Superseded by updateReturnsSettings; remove after the consolidated returns settings page ships. */
export const updateReturnPermissions = {
  name: "updateReturnPermissions" as const,
  input: z.object({
    allowedCompensationMethods: z.array(z.string()),
    allowEditReturn: z.boolean().optional(),
    allowEditFeesAndBonuses: z.boolean().optional(),
    allowEditGreenReturns: z.boolean().optional(),
  }),
  output: z.object({}),
};
